import React, { useState } from 'react';
import Loader from 'components/atoms/loader';
import AiManagementOpenButton from 'components/atoms/ai_management_open_button';
import AiManagementStatusBadge from 'components/atoms/ai_management_status_badge';
import AiManagementPossibleCompetitorDrawer from 'components/organisms/ai_management_possible_competitor_drawer';
import {
  PossibleCompetitorCompany,
  usePossibleCompetitorCompanies,
} from 'hooks/usePossibleCompetitorCompanies';
import { money } from 'services/ai_management_format';
import { companyBadges } from 'services/ai_management_possible_competitors';
import { Card } from './styles';

interface AiManagementCompetitorCompaniesProps {
  biddingId: number | null;
  itemKey: string;
  itemLabel: string;
  period: number;
}

const AiManagementCompetitorCompanies: React.FC<AiManagementCompetitorCompaniesProps> = ({
  biddingId,
  itemKey,
  itemLabel,
  period,
}) => {
  const { companies, loading, error } = usePossibleCompetitorCompanies(biddingId, itemKey, period);
  const [opened, setOpened] = useState<PossibleCompetitorCompany | null>(null);

  if (loading) {
    return (
      <div className="py-4">
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-warning mb-0" role="alert">
        Não foi possível carregar as empresas deste item.
      </div>
    );
  }

  if (!companies.length) {
    return (
      <div className="text-muted py-2">
        Nenhuma empresa venceu este item em licitações parecidas no período.
      </div>
    );
  }

  return (
    <Card className="card overflow-hidden">
      <div className="table-responsive">
        <table className="table mb-0">
          <thead className="thead-light">
            <tr className="text-nowrap">
              <th scope="col">Empresa</th>
              <th scope="col">Média de preço</th>
              <th scope="col">Situação</th>
              <th scope="col">
                <span className="sr-only">Ações</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {companies.map((company) => (
              <tr key={company.cnpj}>
                <td className="company-cell">{company.name ?? company.cnpj}</td>
                <td className="text-nowrap">{money(company.averagePrice)}</td>
                <td>
                  {companyBadges(company).map((badge) => (
                    <AiManagementStatusBadge
                      key={badge.key}
                      tone={badge.tone}
                      className="mr-1 my-1"
                    >
                      {badge.text}
                    </AiManagementStatusBadge>
                  ))}
                </td>
                <td className="text-right">
                  <AiManagementOpenButton
                    label={`Ver detalhes de ${company.name ?? company.cnpj}`}
                    onClick={() => setOpened(company)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {opened ? (
        <AiManagementPossibleCompetitorDrawer
          biddingId={biddingId}
          itemKey={itemKey}
          itemLabel={itemLabel}
          period={period}
          company={opened}
          onClose={() => setOpened(null)}
        />
      ) : null}
    </Card>
  );
};

export default AiManagementCompetitorCompanies;
